/**
 * #1857 lot 7 — Un colis a-t-il une ÉTIQUETTE PDF téléchargeable ?
 *
 * `standardData.labelUrl` n'est PAS une étiquette : c'est le lien de SUIVI DPD, que le webhook
 * recopie à la fois dans `labelUrl` et `trackingUrl`. Le prendre pour une étiquette affichait
 * « Télécharger l'étiquette » sur une collecte à domicile, qui n'a pas de PDF (DPD n'en renvoie
 * pas pour une demande de collecte) — et le téléchargement ne pouvait qu'échouer.
 *
 * Sources d'un vrai PDF = celles que lisent `getFreshLabelUrl` (storagePath, labelStorageUrl) et
 * les replis base64 des écrans staff (labelPdf, ancien emplacement du webhook).
 *
 * Mesuré le 28/09/2026 (acceptance 64 colis, production 229) : tout colis point relais qui porte
 * un `labelUrl` porte aussi l'une de ces sources ; les collectes à domicile n'en portent aucune.
 */
export function hasDownloadableLabel(shipment: any): boolean {
  const standardData = shipment?.standardData;
  return [
    shipment?.labelStorage?.storagePath,
    standardData?.labelStorageUrl,
    standardData?.labelPublicUrl,
    standardData?.labelPdf,
    shipment?.webhookStatus?.stages?.label?.labelPdf,
  ].some(source => typeof source === 'string' && source.trim().length > 0);
}
